module.exports = __webpack_public_path__ + "img/ambulancias.7edc60c4.jpeg";